module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step1-ES.0242d082.png";